import { c as _c } from "react/compiler-runtime";
import Image from '@/components/media/StorefrontImage';
import { cn } from '@/lib/utils';
import styles from './IndustryLogoStrip.module.css';
export interface IndustryLogoStripImage {
  src: string;
  sourceSrc?: string;
  alt: string;
  width?: number;
  height?: number;
  // Skip Next/Image optimization — use when the source asset has a wrong
  // Content-Type in S3 (e.g. binary/octet-stream) and the optimizer rejects
  // it. Browser still sniffs the bytes and renders the image.
  unoptimized?: boolean;
}
export interface IndustryLogoStripContent {
  blockId: string;
  images: IndustryLogoStripImage[];
}
export type IndustryLogoStripVariant = 'default' | 'compact';
export interface IndustryLogoStripProps {
  content: IndustryLogoStripContent;
  variant?: IndustryLogoStripVariant;
  className?: string;
}
const defaultLogoWidth = 180;
const defaultLogoHeight = 90;
export function IndustryLogoStrip(t0) {
  const $ = _c(14);
  const {
    content,
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn(styles.logoStrip, className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = content.blockId;
  const t4 = variant === "compact" && styles.logoGridCompact;
  let t5;
  if ($[2] !== t4) {
    t5 = cn(styles.logoGrid, t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== content.images) {
    t6 = content.images.map(_temp);
    $[4] = content.images;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== content.blockId || $[10] !== t2 || $[11] !== t7 || $[12] !== variant) {
    t8 = <section className={t2} data-cms-block-id={t3} data-logo-strip-variant={variant} aria-label="Customer logos">{t7}</section>;
    $[9] = content.blockId;
    $[10] = t2;
    $[11] = t7;
    $[12] = variant;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
function _temp(logo) {
  return <div key={logo.sourceSrc ?? logo.src} className={styles.logoCell} data-cms-field="images"><Image src={logo.src} alt={logo.alt} width={logo.width ?? defaultLogoWidth} height={logo.height ?? defaultLogoHeight} data-src={logo.sourceSrc ?? logo.src} className={styles.logoImage} loading="lazy" sizes="(min-width: 1024px) 14vw, (min-width: 641px) 28vw, 44vw" unoptimized={logo.unoptimized} /></div>;
}